import React from 'react';
import NavButton from './NavButton'
import {Link} from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles'
import OptimisedImage from '../OptimisedImage';

const styles = {
  paper: {
    background: "#343434",
    overflowY: "auto",
    overflowX: "hidden",
    width: 200,
    borderRight: "none",
  }
};


class Navbar extends React.Component {
  render() {
    const { classes } = this.props;
    var variant = this.props.static ? 'permanent' : 'temporary';

    return <Drawer classes={{ paper: classes.paper }} variant={variant} open={this.props.open} onClose={this.props.callback} style={{display: "block", }}>
      
        <Link to='/' onClick={this.props.callback}>
          <OptimisedImage alt="Supergen Bioenergy Logo" style={{width: 190, height: 115, paddingTop: 10, paddingBottom: 10, display: "block", marginLeft: "auto", marginRight: "auto"}} image={ require('../__assets__/supergen-logo.png') } />
        </Link>

      <div style={{width: "100%"}}>
        <NavButton path="/wiki" name="Bioenergy Wiki" callback={this.props.callback}/>
        <NavButton path="/bioenergy-in-the-uk/" name="Bioenergy in the UK" callback={this.props.callback}/>
        <NavButton path="/ghg-calculator" name="Bioenergy GHG Calculator" callback={this.props.callback}/>
        <NavButton path="/bioenergy-choices/" name="Biomass Resource & Technology Choices" callback={this.props.callback}/>
        <NavButton path="/SDGs" name={"Bioenergy Sustainability"} callback={this.props.callback}/>
        <NavButton path="/conference" name="Conference Questions" callback={this.props.callback}/>

        <Divider style={{width: "80%", border: "1px solid rgb(80, 80, 80)", margin: "12px auto 12px auto"}}/>

        <NavButton path="/your-questions" name="Ask an Expert" callback={this.props.callback}/>
        <NavButton path="/contributors" name="Contributors" callback={this.props.callback}/>
        <NavButton path="/contact-us" name="Contact Us" callback={this.props.callback}/>
      </div>

    </Drawer>
  }
}


export default withStyles(styles)(Navbar)
